import React, { useEffect, useRef, useState } from 'react'
import Modal from "react-modal";
import { useDispatch, useSelector } from 'react-redux';
import { checkAddPermission,checkDeletePermission, checkEditPermission ,dateFormat, fetchBrand, fetchBrandFilter, fetchCategoryData, fetchCategoryDataFilter, fetchOriginData, fetchOriginDataFilter, fetchProductList, fetchProductListFilter, filteredCategories, handleExportFileInventory, handleExportFileProduct, handleImportClickFile, handleSelectionChange, handleUpdateAllCheckbox, handleUpdateDataCheckbox, relatedProductsLoadOptions, TableFooter } from '../../../Utils/helper';
import { deleteApi, getApi, postApi, putApi } from '../../../Services/apiService';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import Import from '../../../Utils/import';
import { toast } from 'react-toastify';
import { AsyncPaginate } from 'react-select-async-paginate';
import MultiSelectDropdown from '../../../Utils/multiSelectDropdown';

function Inventory() {
  const sessionFilterData = JSON.parse(localStorage.getItem('inventoryFilter'))
  const dropdownRef = useRef()
  const { RangePicker } = DatePicker;
  const [methodType, setMethodType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenHistory, setIsOpenHistory] = useState(false);
  const { data } = useSelector((state) => state.roleData);
  const [inventoryData, setInventoryData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(null)
  const [brandData, setBrandData] = useState([])
  const [productListData, setProductListData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [originData, setOriginData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(sessionFilterData?.category || [])
  const [selectedOriginIds, setSelectedOriginIds] = useState(sessionFilterData?.origin || [])
  const [selectedBrandName, setSelectedBrandName] = useState(sessionFilterData?.brand || [])
  const [selectedProductIds, setSelectedProductIds] = useState(sessionFilterData?.product || [])
  console.log("selectedProductIds" , selectedProductIds);
  
  const [brandOpen, setBrandOpen] = useState(false)
  const [originOpen, setOriginOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [productOpen, setProductOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [confirmDeleteToday, setConfirmDeleteToday] = useState(false)
  const [error, setError] = useState(null)
  const [dateState, setDateState] = useState(sessionFilterData?.dateState || {
    startDate: dayjs().format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD')
  });

  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [inventoryEdit, setInventoryEdit] = useState({})
  const [viewHistoryData, setViewHistoryData] = useState({})
  const [historyData, setHistoryData] = useState({})
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDatas, setFilterData] = useState([])
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [deleteData, setDeleteData] = useState({})
  const fetchTimerRef = useRef();
  const abortControllerRef = useRef();

  useEffect(() => {
    localStorage.setItem('inventoryFilter', JSON.stringify({
      'product': selectedProductIds,
      'category': selectedCategoryIds,
      'origin': selectedOriginIds,
      'brand': selectedBrandName,
      'dateState': dateState,
    }))
    handleFetchData();
  }, [searchQuery, selectedBrandName, selectedCategoryIds, selectedOriginIds, selectedProductIds, dateState, currentPage, itemsPerPage])
  
  const handleFetchData = () => {
    const hasFilters =
      selectedBrandName?.length > 0 ||
      selectedCategoryIds?.length > 0 ||
      selectedProductIds?.length > 0 ||
      selectedOriginIds?.length > 0 ||
      searchQuery.trim() !== '';
  
    // Always clear previous timer
    if (fetchTimerRef.current) {
      clearTimeout(fetchTimerRef.current);
    }
  
    // Always abort any in-flight request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  
    // If no filters, stop everything and clear state
    if (!hasFilters) {
      setInventoryData([]);
      setPageCount(null);
      return;
    }
  
    // Set up debounce and fetch
    fetchTimerRef.current = setTimeout(() => {
      abortControllerRef.current = new AbortController();
      fetchInventoryData(abortControllerRef.current.signal);
    }, 500);
  };

  useEffect(() => {
    fetchCategoryData('', setCategoryData);
    fetchOriginData('', setOriginData);
    fetchBrand('', setBrandData);
    fetchProductList('', setProductListData)
  }, [])

  useEffect(() => {
    const handleKeyDown = (event) => {
      // ESC key closes any open modal
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false)
      }
      // Enter key submits the form in modals
      if ((event.key === 'Enter'||event.key === 'return') && isOpen) {
        event.preventDefault();
        document.getElementById('modal-save-btn')?.click();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);


  // const fetchBrand = async () => {
  //   const resp = await getApi(`/brand?per_page=50`);
  //   if (resp?.success === true) {
  //     setBrandData(resp?.data?.brands || []);
  //   }
  // }
  // const fetchProductList = async () => {
  //   const resp = await getApi(`/product?search=&per_page=50`);
  //   if (resp?.success === true) {
  //     setProductListData(resp?.data?.products?.data || []);
  //   }
  // }
  // const fetchCategoryData = async () => {
  //   const resp = await getApi(`/product-category?per_page=50`);
  //   if (resp?.success === true) {
  //     setCategoryData(resp?.data?.productCategories?.data || []);
  //   }
  // }
  // const fetchOriginData = async () => {
  //   const resp = await getApi(`/product-origin?per_page=50`);
  //   if (resp?.success === true) {
  //     setOriginData(resp?.data?.productOrigins?.data || []);
  //   }
  // }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProductOpen(false);
        setBrandOpen(false)
        setCategoryOpen(false)
        setOriginOpen(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  
  useEffect(() => {
    if (searchTerm !== '') {
      // filterData()
      if (categoryOpen) {
        const data = filteredCategories(searchTerm, categoryData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (originOpen) {
        const data = filteredCategories(searchTerm, originData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (brandOpen) {
        const data = filteredCategories(searchTerm, brandData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (productOpen) {
        const data = filteredCategories(searchTerm, productListData);
        setFilterData(data?.length > 0 ? data : []);
      }
    }
  }, [searchTerm])

  const hasValidFilters =
  selectedBrandName?.length > 0 ||
  selectedCategoryIds?.length > 0 ||
  selectedProductIds?.length > 0 ||
  selectedOriginIds?.length > 0 ||
  searchQuery.trim() !== '';

  const fetchInventoryData = async (signal) => {
    setIsLoading(true);
    const queryParams = new URLSearchParams();
    if (Array.isArray(selectedCategoryIds)) {
      selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
    } else if (selectedCategoryIds) {
      queryParams.append('category_ids[]', selectedCategoryIds);
    }
    if (Array.isArray(selectedProductIds)) {
      selectedProductIds.forEach((id) => queryParams.append('product_ids[]', id));
    } else if (selectedProductIds) {
      queryParams.append('product_ids[]', selectedProductIds);
    }
    if (Array.isArray(selectedOriginIds)) {
      selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
    } else if (selectedOriginIds) {
      queryParams.append('origin_ids[]', selectedOriginIds);
    }
    if (Array.isArray(selectedBrandName)) {
      selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
    } else if (selectedBrandName) {
      queryParams.append('brands[]', selectedBrandName);
    }
    queryParams.append('search', searchQuery);
    queryParams.append('page', currentPage);
    queryParams.append('per_page', itemsPerPage);
    queryParams.append('from_date', dateState?.startDate);
    queryParams.append('to_date', dateState?.endDate);
    try {
      const resp = await getApi(`/inventory/v2?${queryParams.toString()}`, { signal })
      if (resp?.success) {
        setInventoryData(resp?.data?.inventories?.data)
        setPageCount(resp?.data?.inventories?.last_page)
      }
    } catch (e) {
      
    }
    finally {
      setIsLoading(false);
    } 
  
  }

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  const createToggleHandler = (data, findFn, setState) => (selectedName) => {
    const selectedItem = data.find(item => findFn(item, selectedName));
    if (selectedItem) {
      setState(prevIds => {
        const identifier = selectedItem.id ?? selectedItem; // Handle both objects and primitives
        return prevIds.includes(identifier)
          ? prevIds.filter(id => id !== identifier)
          : [...prevIds, identifier];
      });
    }
  };

  const handleProductChange = createToggleHandler(
    productListData,
    (cat, name) => cat.name_en === name,
    setSelectedProductIds
  );
  const handleCategoryChange = createToggleHandler(
    categoryData,
    (cat, name) => cat.name === name,
    setSelectedCategoryIds
  );

  const handleOriginChange = createToggleHandler(
    originData,
    (origin, name) => origin.name === name,
    setSelectedOriginIds
  );

  const handleBrandChange = createToggleHandler(
    brandData,
    (brand, name) => brand === name,
    setSelectedBrandName
  );

  const handleDateFilterChange = (dates) => {
    if (dates) {
      setDateState({
        startDate: dates[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
        endDate: dates[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null
      });
    } else {
      setDateState({
        startDate: null,
        endDate: null
      });
    }

  }

  const handleEditData = (inventory) => {
    if (new Date(inventory.date) > new Date()) {
      return; // Do nothing if the inventory date is in the future
    }
    setIsOpen(true)
    setInventoryEdit(inventory)
  }

  const handleUpdateActualStock = async () => {
    try {
      setIsLoading(true)
      const urlEncodedData = new URLSearchParams();
      urlEncodedData.append('actual_stock', inventoryEdit?.actual_stock);
      urlEncodedData.append('date', inventoryEdit?.date);
      urlEncodedData.append('product_id', inventoryEdit?.product_id);
      const response = await postApi(`/inventory`, urlEncodedData.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      if (response?.success) {
        toast.success(response.msg || `Inventory updated successfully`);
         handleFetchData();
        setIsOpen(false)
      } else {
        toast.error(response?.msg || `Failed to update Inventory`);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || `Failed to update Inventory`;
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  }

  const handleViewHistory = async (inventory) => {
    setIsOpenHistory(true)
    const resp = await getApi(`/inventory/${inventory?.inventory_id}`)
    // if (resp?.success) {
    setViewHistoryData(resp?.data)
    // }
    if (resp?.success) {
      const slicedHistory = Object.entries(resp?.data?.histories || {})
        .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA));

      const sortedHistory = slicedHistory
      // const sortedHistory = slicedHistory.length === 2 
      //   ? slicedHistory.slice(0, 2)
      //   : slicedHistory.slice(0, 3);
      const latestTwoEntries = sortedHistory.reduce((result, [date, value]) => {
        result[date] = value;
        return result;
      }, {});

      setHistoryData(latestTwoEntries)
    }
  }

  const queryParamsData = {
    'from_date': dateState?.startDate,
    'to_date': dateState?.endDate,
    'export': 1
  }

  const handleDelete = async (x) => {
    setDeleteOpen(true)
    setDeleteData(x)
  }

  const handleDeleteTodayInventory = async () => {
    // First check if there are any inventories for today
    try {
      setIsLoading(true);

      const today = new Date().toISOString().split('T')[0];
      const queryParams = new URLSearchParams();
      queryParams.append('from_date', today);
      queryParams.append('to_date', today);
      queryParams.append('page', 1);
      queryParams.append('per_page', 1);
      queryParams.append('has_actual', 1);
      const checkResp = await getApi(`/inventory/v2?${queryParams.toString()}`);
      if (checkResp?.success && checkResp?.data?.inventories?.data?.length > 0) {
        // If inventories exist for today, show confirmation modal
        setConfirmDeleteToday(true)
      } else {
        // If no inventories exist for today, show error toast
        toast.error('No inventory exists for today to delete');
      }
    } catch (error) {
      toast.error('Error checking today\'s inventory');
      console.error(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const confirmDeleteTodayInventory = async () => {
    setIsLoading(true);
    try {
      const today = new Date();
      const date = today.toISOString().split('T')[0];
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const aliasMap = {
        'Asia/Calcutta': 'Asia/Kolkata',
        // add others as needed
      };
      const canonical = aliasMap[timeZone] || timeZone;

      const queryParams = `?date=${encodeURIComponent(date)}&timezone=${encodeURIComponent(canonical)}`;
      const resp = await deleteApi(`/inventory/delete-today${queryParams}`);

      if (resp?.success) {
        toast.success('Today\'s inventory deleted successfully');
         handleFetchData();
      } else {
        toast.error(resp?.msg || 'Failed to delete today\'s inventory');
      }
    } catch (error) {
      toast.error('An error occurred while deleting inventory');
      console.error(error);
    } finally {
      setIsLoading(false);
      setConfirmDeleteToday(false)
    }
  };


  const DeleteInventory = async () => {
    setIsLoading(true)
    const resp = await deleteApi(`/inventory/${deleteData?.id}`)
    if (resp?.success) {
      toast.success('Daily inventory delete successfully')
       handleFetchData()
    }
    setIsLoading(false)
    setDeleteOpen(false)
  }


  
  return (
    <div className="RightSideDiv daily-inventory">
      {showImportModal &&

        <Import setImportFile={setImportFile} importFile={importFile} searchQuery={searchQuery} fetchData={handleFetchData} setShowImportModal={setShowImportModal} routeEnd={'/inventory/import'} routeexport={'/inventory/v2'} type='Inventory' queryParams={queryParamsData} />
      }
      {methodType === "" && (
        <div class="row">
          <div class="col-sm-12">
            <div className="setting-right setting-right-table product-grouping arrival">
              <div class="table-header">
                <div className="header-left">
                  <div class="search-card">
                    <img
                      src={window.getPublicUrl(
                        "/assets/images/search-icon.svg"
                      )}
                      alt=""
                    />
                    <input
                      type="text"
                      class="search-input"
                      placeholder="Search Product code/name."
                      value={searchQuery}
                      onChange={(e) => {setSearchQuery(e.target.value);setCurrentPage(1)}}
                    />
                  </div>
                  {/* <button class="btn">
                     <img src="" alt="" />
                     Main Product Grouping{" "}
                   </button> */}
                  <div className="table-second">
                    <div className="links">
                      {/* <div className='selctions-option'>
                        <input placeholder="product Name" class={`category affter-change-cs category-select product-name ${productOpen ? 'before-change-cs' : ''}`} value={productOpen ? searchTerm : ''} onChange={(e) => setSearchTerm(e?.target?.value)} onClick={() => { setProductOpen(!productOpen); setSearchTerm('') }} />
                        {productOpen &&
                          <div className='select-option' ref={dropdownRef}>

                            {(searchTerm === '' ? productListData?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? productListData : filterDatas).map((x, index) => (
                              <span>
                                <label class="checbox-cs">
                                  <input type="checkbox" onClick={(e) => handleProductChange(x?.name_en)} checked={selectedProductIds.includes(x?.id) ? true : false} />
                                  <span class="checkmark" ></span>
                                </label>
                                {x?.name_en}
                              </span>
                            ))
                              :
                              <span className="no-data-available">No Product Available</span>
                            }
                          </div>
                        }
                      </div> */}

                        <MultiSelectDropdown
                          categoryData={productListData}
                          selectedCategories={selectedProductIds}
                          setSelectedCategories={setSelectedProductIds}
                          placeholder='Select Product...'
                          noOptionsMessage='No product available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchProductListFilter}
                        />
                      {/* <AsyncPaginate
                        value={
                          // formData.related_product
                          // ? {
                          // value: formData.id,
                          // label: `${formData.name} | (${formData.code})`,
                          // }
                          // : null
                          ''
                        }
                        loadOptions={relatedProductsLoadOptions('productName', setSelectedProductIds)}
                        onChange={handleSelectionChange('productName', setSelectedProductIds)}
                        placeholder="Search and select related product"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}
                      <div className='selctions-option'>
                        <RangePicker
                          key={'pathName'}
                          onChange={handleDateFilterChange}
                          separator={'-'}
                          // placeholder={[t('FROM'), t('TO')]}
                          // disabledDate={(current) => current && current < dayjs().startOf('day')}
                          value={[
                            dateState.startDate ? dayjs(dateState.startDate) : null,
                            dateState.endDate ? dayjs(dateState.endDate) : null
                          ]}
                          allowClear={false}
                        />
                      </div>
                      {/* <div className='selctions-option'>
                        <input placeholder="category" className={`category affter-change-cs category-select ${categoryOpen ? 'before-change-cs' :''}`} value={categoryOpen?searchTerm:''} onChange={(e)=>setSearchTerm(e?.target?.value)} onClick={() => {setCategoryOpen(!categoryOpen);setSearchTerm('')}}/>
                        {categoryOpen &&
                        <div className='select-option' ref={dropdownRef}>
                          
                            {categoryData && (searchTerm==='' ? categoryData?.length >0 :filterDatas?.length>0) ? (searchTerm==='' ? categoryData : filterDatas)?.map((x,index)=>{
                              return(
                                <span key={index}>
                                <label className="checbox-cs">
                                <input type="checkbox" onClick={(e) => handleCategoryChange(x?.name)} checked={selectedCategoryIds.includes(x?.id) ? true : false}/>
                                <span className="checkmark"></span>
                              </label>
                              {x?.name}
                            </span>
                              )
                            })
                          :
                          <span className="no-data-available">No Categories Available</span>
                          }
                        </div>
}
                      </div> */}

                        <MultiSelectDropdown
                          categoryData={categoryData}
                          selectedCategories={selectedCategoryIds}
                          setSelectedCategories={setSelectedCategoryIds}
                          placeholder='Select Categories...'
                          noOptionsMessage='No categories available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchCategoryDataFilter}
                        />
                      {/* <AsyncPaginate
                        value={
                          // formData.related_product
                          // ? {
                          // value: formData.id,
                          // label: `${formData.name} | (${formData.code})`,
                          // }
                          // : null
                          ''
                        }
                        loadOptions={relatedProductsLoadOptions('category', setSelectedCategoryIds)}
                        onChange={handleSelectionChange('category', setSelectedCategoryIds)}
                        placeholder="Search and select related category"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}
                        <MultiSelectDropdown
                          categoryData={originData}
                          selectedCategories={selectedOriginIds}
                          setSelectedCategories={setSelectedOriginIds}
                          placeholder="Select origin..."
                          noOptionsMessage='No origin available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchOriginDataFilter}
                        />
                      {/* <div className='selctions-option'>
                        <input placeholder="origin" className={`category affter-change-cs category-select ${originOpen ? 'before-change-cs' : ''}`} value={originOpen ? searchTerm : ''} onChange={(e) => setSearchTerm(e?.target?.value)} onClick={() => { setOriginOpen(!originOpen); setSearchTerm('') }} />
                        {originOpen &&
                          <div className='select-option' ref={dropdownRef}>
                            {(searchTerm === '' ? originData?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? originData : filterDatas).map((x, index) => (
                              <span key={index}>
                                <label class="checbox-cs">
                                  <input type="checkbox" onClick={(e) => handleOriginChange(x?.name)} checked={selectedOriginIds.includes(x?.id) ? true : false} />
                                  <span class="checkmark" ></span>
                                </label>
                                {x.name}
                              </span>
                            ))
                              :
                              <span className="no-data-available">No Origin Available</span>
                            }
                          </div>
                        }
                      </div> */}
                      {/* <AsyncPaginate
                        value={
                          // formData.related_product
                          // ? {
                          // value: formData.id,
                          // label: `${formData.name} | (${formData.code})`,
                          // }
                          // : null
                          ''
                        }
                        loadOptions={relatedProductsLoadOptions('origin', setSelectedOriginIds)}
                        onChange={handleSelectionChange('origin', setSelectedOriginIds)}
                        placeholder="Search and select related origin"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}
                      {/* <div className='selctions-option'>
                        <input placeholder="brand" className={`category affter-change-cs category-select ${brandOpen ? 'before-change-cs' : ''}`} value={brandOpen ? searchTerm : ''} onChange={(e) => setSearchTerm(e?.target?.value)} onClick={() => { setBrandOpen(!brandOpen); setSearchTerm('') }} />
                        {brandOpen &&
                          <div className='select-option' ref={dropdownRef}>
                            {(searchTerm === '' ? brandData?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? brandData : filterDatas).map((x, index) => (
                              <span key={index}>
                                <label class="checbox-cs">
                                  <input type="checkbox" onClick={(e) => handleBrandChange(x)} checked={selectedBrandName.includes(x) ? true : false} />
                                  <span class="checkmark" ></span>
                                </label>
                                {x}
                              </span>
                            ))
                              :
                              <span className="no-data-available">No Brand Available</span>
                            }
                          </div>
                        }
                      </div> */}
                        <MultiSelectDropdown
                          categoryData={brandData}
                          selectedCategories={selectedBrandName}
                          setSelectedCategories={setSelectedBrandName}
                          placeholder="Select brand..."
                          noOptionsMessage='No brand available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchBrandFilter}
                        />
                      {/* <AsyncPaginate
                        value={
                          // formData.related_product
                          // ? {
                          // value: formData.id,
                          // label: `${formData.name} | (${formData.code})`,
                          // }
                          // : null
                          ''
                        }
                        loadOptions={relatedProductsLoadOptions('brand', setSelectedBrandName)}
                        onChange={handleSelectionChange('brand', setSelectedBrandName)}
                        placeholder="Search and select related brand"
                        isClearable
                        // isLoading={loading}
                        additional={{
                          page: 1,
                        }}
                      /> */}
                    </div>
                  </div>
                </div>
                <div class="table-actions">
                {checkDeletePermission(data?.permissions, 'daily_inventory') && (
                  <button class="btn delete-btn"
                    onClick={() => handleDeleteTodayInventory()}>
                    <img

                      alt=""
                    />
                    Delete All Daily Inventory Today
                  </button>
                )}
                  {checkAddPermission(data?.permissions, 'daily_inventory') && (
                  <button class="btn" onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                    <img
                      src={window.getPublicUrl("/assets/images/import.svg")}
                      alt=""
                    />
                    Import
                  </button>
                  )}
                  <button class="btn" onClick={() => handleExportFileInventory(productListData, searchQuery, 'inventory.xlsx', '/inventory/v2', selectedBrandName, selectedCategoryIds, selectedOriginIds, selectedProductIds, dateState)}>
                    <img
                      src={window.getPublicUrl("/assets/images/export.svg")}
                      alt=""
                    />
                    Export
                  </button>

                  {/* {checkAddPermission(data?.permissions, 'daily_inventory') && (
                                          <button class="btn add" onClick={() => setMethodType("add")}>
                                          + Add New Product Group
                                        </button>
                                     )} */}
                </div>
              </div>

              <div className="permission-table-inner">
                <table class="custom-table table-striped ">
                  <thead>
                    <tr>
                      {/* <th class="checkbox">
                        <label class="checbox-cs">
                          <input type="checkbox" onClick={(e) => handleUpdateAllCheckbox(e?.target?.checked, setInventoryData)} />
                          <span class="checkmark"></span>
                        </label>
                      </th> */}
                      <th class="gr-no">Date</th>
                      <th class="code">Product Code</th>
                      <th class="name-en">Product Name</th>
                      <th class="name-tc">Estimated Stock</th>
                      <th class="category actial-stock">Actual Stock</th>
                      <th class="coo">Updated By</th>
                      <th class="update">Updated At</th>
                      <th class="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="6" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : (inventoryData?.length === 0 || !hasValidFilters)  ? (
                      <tr>
                        {(selectedBrandName?.length==0 && selectedCategoryIds?.length==0 && selectedProductIds?.length==0 && selectedOriginIds?.length==0 && searchQuery==='')
                        ?
                        <td colSpan="10" className="text-center">{'Please select a filter to view data'}</td>
                        :
                        <td colSpan="10" className="text-center">No products found</td>
                        }
                      </tr>
                    ) : (
                      inventoryData?.length > 0 && inventoryData?.map((inventory, index) => (
                        <tr key={inventory.product_id + inventory.date}>
                          {/* <td class="checkbox">
                            <label class="checbox-cs">
                              <input type="checkbox" onClick={(e) => handleUpdateDataCheckbox(inventory, e, setInventoryData)} checked={inventory?.status} />
                              <span class="checkmark"></span>
                            </label>
                          </td> */}
                          <td class="gr-no">{inventory?.date}</td>
                          <td class="code">{inventory?.product_code}</td>
                          <td class="name-en">{inventory?.product_name_tc}</td>
                          <td class="name-tc">{inventory?.estimated_stock}</td>
                          <td class="category actial-stock">
                            <input type="text"
                                   placeholder=""
                                   value={inventory?.previous_actual_stock != null ? `${inventory?.previous_actual_stock} -> ${inventory?.actual_stock}` : inventory?.actual_stock}
                                   disabled={new Date(inventory.date) > new Date()}
                                   onClick={() => handleEditData(inventory)} />
                          </td>
                          <td class="coo">{inventory?.updated_by}</td>
                          <td className="update">
                            {inventory?.updated_at && (() => {
                              const dt = new Date(inventory.updated_at);

                              const datePart = dt.toLocaleDateString('en-IN', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                              });

                              const timePart = dt.toLocaleTimeString('en-IN', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                              });

                              return `${datePart}, ${timePart}`;
                            })()}
                          </td>
                          {/* <td class="update">{inventory?.updated_at ? new Date(inventory.updated_at).toLocaleDateString() : ''}</td> */}
                          <td class="action action-cs">
                          {/* {checkDeletePermission(data?.permissions, 'daily_inventory'|| inventory?.histories_count > 1  ) && ( */}
                          
                            <div className="dropdown">


                            {/* {( ( checkDeletePermission(data?.permissions, 'daily_inventory') ||inventory?.histories_count > 1 ||  */}
                            {((inventory?.histories_count > 1 || 



                              inventory?.date === new Date().toISOString().slice(0, 10)) &&
                              inventory?.inventory_id) && (
                              <button
                                className="dropdown-toggle action-btn"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  src={window.getPublicUrl(
                                    "/assets/images/dots-icon.svg"
                                  )}
                                  alt=""
                                />
                              </button>
                                )}
                              {(inventory?.histories_count > 1 || inventory.date === new Date().toISOString().slice(0, 10)) && (
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                  {inventory?.histories_count > 1 && (<li>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleViewHistory(inventory);
                                      }}
                                    >
                                      View History
                                    </a>
                                  </li>)}
                                  {checkDeletePermission(data?.permissions, 'daily_inventory') &&
            inventory?.date === new Date().toISOString().slice(0, 10) && (
                // {inventory.date === new Date().toISOString().slice(0, 10) && (
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDelete(inventory);
                                        }}
                                      >
                                        Delete
                                      </a>
                                    </li>)}
                                </ul>
                              )}
                            </div>

                          </td>
                        </tr>
                      )))}
                  </tbody>
                </table>

              </div>
              <div class="table-footer d-flex justify-content-between table-pagination">
                <select name="" id="" className='affter-change-cs page' value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                </select>
                <div className=''>
                  <TableFooter
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      <Modal
        isOpen={deleteOpen}
        onRequestClose={() => { setDeleteOpen(false); setDeleteData({}) }}
        contentLabel="Example Modal"
        className="custom-modal add-custom-stock"
        overlayClassName="custom-overlay"
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
      >
        <div className="modal-overlay file-upload-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Actual Stock</h3>
              <span>
                <img
                  src={window.getPublicUrl('/assets/images/close.svg')}
                  onClick={() => { setDeleteOpen(false); setDeleteData({}) }}
                  className="close"
                  alt="Close"
                /></span>
            </div>
            <div className="modal-body mb-0 p-0">
              <p>Are you sure you want to delete this Inventory?</p>
            </div>
            <div className="modal-footer">
              <button className="reset" onClick={() => { setDeleteOpen(false); setDeleteData({}) }}>
                Cancel
              </button>
              <button
                className="save mt-0"
                onClick={() => DeleteInventory()}
                disabled=''
              >

                {isLoading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                Delete
              </button>
            </div>
          </div>
        </div>

      </Modal>
        <Modal
          isOpen={confirmDeleteToday}
          onRequestClose={() => setConfirmDeleteToday(false)}
          contentLabel="Confirm Delete Modal"
          className="custom-modal confirm-delete-modal"
          overlayClassName="custom-overlay"
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-overlay file-upload-modal">
            <div className="modal-content">
              <div className="modal-header">
                <h3>Confirm Delete</h3>
                <span>
                  <img
                    src={window.getPublicUrl('/assets/images/close.svg')}
                    onClick={() => setConfirmDeleteToday(false)}
                    className="close"
                    alt="Close"
                  />
                </span>
              </div>
              <div className="modal-body mb-0 p-0">
                <p>Are you sure you want to delete all of today's inventory?</p>
                <p>This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button className="reset" onClick={() => setConfirmDeleteToday(false)}>
                  Cancel
                </button>
                <button
                  className="save mt-0"
                  onClick={confirmDeleteTodayInventory}
                  disabled={isLoading}
                >
                  {isLoading && (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  )}
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>
          {checkEditPermission(data?.permissions, 'daily_inventory') && (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Example Modal"
        className="custom-modal add-custom-stock"
        overlayClassName="custom-overlay"
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
      >
        <div className="modal-overlay file-upload-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Actual Stock</h3>
              <span>
                <img
                  src={window.getPublicUrl('/assets/images/close.svg')}
                  onClick={() => setIsOpen(false)}
                  className="close"
                  alt="Close"
                /></span>
            </div>
            <div className="modal-body mb-0 p-0">
              <p>Please enter the updated actual stock value. This will replace the estimated stock value.</p>
              <p className='estimate-stock'>Estimated Stock  :  <span>{inventoryEdit?.estimated_stock}</span></p>
              <div class="form-group">
                <label for="actual-stock" className='d-block'>Actual Stock</label>
                <input type="number" class="" id="actual-stock" placeholder="Enter Actual Stock" value={inventoryEdit?.actual_stock}
                  onChange={(e) => setInventoryEdit(prev => ({
                    ...prev,
                    actual_stock: e.target.value
                  }))}
                />
              </div>
            </div>
            <div className="modal-footer">
              {/* <button className="reset" onClick=''>
                Reset
              </button> */}
              <button
              id='modal-save-btn'
                className="save mt-0"
                onClick={() => handleUpdateActualStock()}
                disabled={isLoading}
              >

                {isLoading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                Save
              </button>
            </div>
          </div>
        </div>

      </Modal>
          )}
      <Modal
        isOpen={isOpenHistory}
        onRequestClose={() => setIsOpenHistory(false)}
        contentLabel="Example Modal"
        // className="custom-modal add-custom-stock "
        overlayClassName="modal-overlay add-category delete logout view-history-details "
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
        portalClassName="add-user delete  inventory-history-cs"
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h3>History</h3>
            <img
              src={window.getPublicUrl('/assets/images/close.svg')}
              onClick={() => { setIsOpenHistory(false) }}
              className="close"
              alt="Close"
            />
          </div>
          <div className='onscroll-history reserve-history'>
            <div className='modal-body mb-0 p-0'>
              <div className='permission-table-inner arrival main-head reserve-history'>
                <div className="mb-4 w-100 d-flex align-items-center ">
                  <h3> <span>{(() => {
                                        const nextEntry = Object.entries(historyData);
                                        const lastEntry = nextEntry.at(0);
                                        const nextDate = lastEntry?.[0];
                                        if (nextDate) {
                                          return <h3>{dateFormat(nextDate)}</h3>;
                                        }
                                        return null;
                                      })()}</span></h3>



                  {/* <div className='permission-table-inner'> */}
                  <table class="custom-table table-striped">
                    <thead>
                      <tr>
                        <th class="gr-no">Date</th>
                        <th class="code">Product Code</th>
                        <th class="name-en">Product Name</th>
                        {/* <th class="name-tc">Estimated Stock</th> */}
                        <th class="category actial-stock">Actual Stock</th>
                        <th class="coo">Updated By</th>
                        <th class="update">Updated At</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="gr-no">{viewHistoryData?.inventory?.date}</td>
                        <td class="code">{viewHistoryData?.inventory?.product_code}</td>
                        <td class="name-en">{viewHistoryData?.inventory?.product_name_tc}</td>
                        {/* <td class="name-tc">{viewHistoryData?.inventory?.estimated_stock}</td> */}
                        <td class="category actial-stock"><input type="text" placeholder="100" value={viewHistoryData?.inventory?.actual_stock} /></td>
                        <td class="coo">{viewHistoryData?.inventory?.updated_by}</td>
                        <td class="update">{viewHistoryData?.inventory?.updated_at ? new Date(viewHistoryData?.inventory?.updated_at).toLocaleDateString() : ''}</td>
                      </tr>
                    </tbody>
                  </table>
                  {/* </div> */}
                </div>
              </div>
            </div>
            <div className='modal-footer text-start justify-content-start'>
              {historyData && Object.entries(historyData).sort((a, b) => new Date(b[0]) - new Date(a[0])).map(([date, changes], index,allEntries) => {
                
                if (index === allEntries.length - 1) return null;
                const getOldOrCurrentValue = (fieldName, currentValue) => {
                  const fieldChange = changes.find(change => change.column_name === fieldName);
                  return fieldChange?.old_value || currentValue;
                };
                if (index != Object.entries(historyData)?.length - 1) {
                  return (
                    <div key={index} className="mb-4 w-100 d-flex align-items-center">
                      <h3> <span>{(() => {
                                        const nextEntry = Object.entries(allEntries)[index + 1];
                                        const nextDate = nextEntry?.[1]?.[0];
                                        if (nextDate) {
                                          return <h3>{dateFormat(nextDate)}</h3>;
                                        }
                                        return null;
                                      })()}</span></h3>
                      <table className='custom-table table-striped ms-0'>
                        <tbody>
                          <tr>
                            <td class="gr-no">{getOldOrCurrentValue("date", viewHistoryData?.inventory?.date)}</td>
                            <td class="code">{getOldOrCurrentValue("product_code", viewHistoryData?.inventory?.product_code)}</td>
                            <td class="name-en">{getOldOrCurrentValue("product_name_tc", viewHistoryData?.inventory?.product_name_tc)}</td>
                            {/* <td class="name-tc">{getOldOrCurrentValue("estimated_stock", viewHistoryData?.inventory?.estimated_stock)}</td> */}
                            <td class="category actial-stock"><input type="text" placeholder="100" value={getOldOrCurrentValue("actual_stock", viewHistoryData?.inventory?.actual_stock)} /></td>
                            <td class="coo">{getOldOrCurrentValue("changed_by", viewHistoryData?.inventory?.updated_by)}</td>
                            <td class="update">{getOldOrCurrentValue("changed_at", viewHistoryData?.inventory?.updated_at ? new Date(viewHistoryData?.inventory?.updated_at).toLocaleDateString() : '')}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  );
                }
              })}
            </div>
          </div>

        </div>

      </Modal>


    </div>
  );
}

export default Inventory